import { csx } from '@vtex/admin-ui'

export const styles = {
  content: csx({ gap: '$space-5' }),
}
